/**
 * Left navigation module sequence per docs/01_PRODUCT/02_GLOBAL_NAVIGATION.md
 * and docs/02_DESIGN/01_INFORMATION_ARCHITECTURE.md.
 * K.0: structural shell only — module routes arrive in later K waves.
 */

export interface NavModule {
  id: string;
  label: string;
  /** Reserved path for future module mounting. */
  path: string;
  available: boolean;
}

export const HQ_NAV_MODULES: readonly NavModule[] = [
  { id: "dashboard", label: "Dashboard", path: "/app/dashboard", available: true },
  { id: "users", label: "Users", path: "/app/users", available: true },
  { id: "creators", label: "Creator Center", path: "/app/creators", available: true },
  { id: "businesses", label: "Business Center", path: "/app/businesses", available: true },
  { id: "communities", label: "Communities", path: "/app/communities", available: true },
  { id: "bookings", label: "Bookings", path: "/app/bookings", available: true },
  { id: "trust-safety", label: "Trust & Safety", path: "/app/trust-safety", available: true },
  { id: "support", label: "Support", path: "/app/support", available: true },
  { id: "finance", label: "Finance", path: "/app/finance", available: true },
  { id: "marketing", label: "Marketing", path: "/app/marketing", available: true },
  { id: "marketplace", label: "Marketplace Health", path: "/app/marketplace", available: true },
  { id: "analytics", label: "Analytics", path: "/app/analytics", available: true },
  { id: "knowledge", label: "Knowledge Base", path: "/app/knowledge", available: true },
  { id: "tasks", label: "Task Center", path: "/app/tasks", available: true },
  { id: "approvals", label: "Approvals", path: "/app/approvals", available: true },
  { id: "staff", label: "Staff", path: "/app/staff", available: true },
  { id: "system", label: "System", path: "/app/system", available: true },
] as const;
